export enum DefaultsGroup {
    GRAPHICS = 3,
}
